import { render } from "./ObjectiveTableHeaderOptions.vue?vue&type=template&id=f7f84ae0&scoped=true"
import script from "./ObjectiveTableHeaderOptions.vue?vue&type=script&lang=js"
export * from "./ObjectiveTableHeaderOptions.vue?vue&type=script&lang=js"

import "./ObjectiveTableHeaderOptions.vue?vue&type=style&index=0&id=f7f84ae0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7f84ae0"]])

export default __exports__